define('views/modules/conversation/conversation-manager',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/events/conversation-events',
    // views
    'views/parts/panel/base-panel',
    'views/modules/conversation/conversation-manager-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    ConversationEvents,
    // views
    VBasePanel,
    VConversationManagerContent
) {

    var VConversationManager = VBasePanel.extend({
        header: {
            title: "Messages",
            subtitle: "Your ongoing conversations",
        },
        tabs: function() {
            var tabs = [{ id: 'inbox', title: 'conversation:Inbox', icon: 'sl-icon-envelope', active: true, callback: 'showInbox' }];

            return tabs;
        },
        content: {
            inbox: VConversationManagerContent,
        },
        defaultView: 'inbox',
        initialize: function(opt) {
            opt = this.options = opt || {};

            this.group = opt.group;

            var inbox = this.getView('inbox');
            this.listenTo(inbox, {
                'member:select': this.close,
            });

            this.listenTo(ConversationEvents, {
                'stack:showQuestionnaireResponse': this.onShowQuestionnaireResponse,
                'conversation:userSelected': this.close
            });
        },

        getContentViewOptions: function(options) {
            return _.extend({
                model: this.model,
                group: this.group,
                url: this.options.url,
                role: this.options.role
            }, options);
        },

        showInbox: function() {
            return this.showContent('inbox');
        },

        onShowQuestionnaireResponse: function(panel) {
            this.trigger("panel:stack", panel);
        },

    });

    return VConversationManager;
});

